import { Col, Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import "../../scss/freelancing-guide-styling-components/tip-section.style.scss";
import { useTranslation } from "react-i18next";
import { TipsHeroImage } from "../images/png/icons";
import { Tips } from "../../constant/tips-section.constant";

export const TipSection = () => {
  const { t } = useTranslation();
  const BOOTSTRAP_MD_BREAKPOINT = 768;
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
  const isMobile = window.innerWidth < 576;

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container className="tip-section-container padding-140-tip-section">
      <Row className={`tip-section-row align-items-center ${isLargeScreen ? "large-screen" : ""}`}>
        <Col md={6} className="tip-section-content-col px-0 half-stretch-content">
          <div className={`tip-section-content${isLargeScreen ? " large" : ""}`}>
            <h2 className="tip-section-title">{t("TIPS_SECTION_TITLE")}</h2>
            <div style={{ height: "2rem" }} />
            <p className="tip-section-description">{t("TIPS_SECTION_DESC")}</p>
            <div style={{ height: "3rem" }} />
            <Row>
              {Tips.map(({ icon, title, description }, idx) => (
                <Col md={12} key={idx} className="tip-section-feature-col">
                  <div>
                    <div className="tip-section-feature-row">
                      <div className="tip-section-feature-icon">
                        <img src={icon} alt={t(title)} />
                      </div>
                      <div className="tip-section-feature-title-wrap">
                        <h5 className="tip-section-feature-title">{t(title)}</h5>
                      </div>
                    </div>
                    <p className="tip-section-feature-description">{t(description)}</p>
                  </div>
                </Col>
              ))}
            </Row>
          {isMobile && <img src={TipsHeroImage} alt={t("TIPS_SECTION_TITLE")} className="tip-section-image" />}
          </div>
        </Col>

        {!isMobile && (
          <Col md={6} className="px-0 half-stretch">
            <img src={TipsHeroImage} alt={t("TIPS_SECTION_TITLE")} className="tip-section-image" />
          </Col>
        )}
      </Row>
    </Container>
  );
};
